import { setTerms } from './helpers';

export const setConstructionTypes = setTerms('house_material');
